import React from "react";
import { getStyle } from "../../styles/styles";
import { getCurrenciesDenominationsByCustomer, getCurrencyList } from "../../networking/NetworkingCurrencies";
import { getLookUpTable } from "../../networking/Networking";
import WizardSearchCustomerForm from "../trade/wizard/WizardSearchCustomerForm";
import { Breadcrumb } from "antd";
import SettlementApplicationForm from "./SettlementApplicationForm";
import { getInstrumentsByCustomer } from "../../networking/NetworkingInstruments";

var style = getStyle();

export default class SettlementScreen extends React.Component {
    state = {
        settlementID: 0,
        objCustomer: {},
        step: 1,
        listInstruments : [],
        listActiveCurrencies : [],
        typeRecordsApply : ''
    }

    componentDidMount(){
        if(this.props.data !== undefined && this.props.data > 0){
            this.setState({
                settlementID: this.props.data
            });
        } else {
            //this.loadCurrencyList(1242);
            this.loadInstruments();
        }
    }
    
    handleBackLink() {
        this.props.backLink();
    }
    
    onClickStepTab = (value) => {
        if(this.state.step === 1){
            //Nothing at all
        }
        else{
            this.setState({step: value});            
        }
    }
    
    ///Customer screen
    handleCustomerSelection(obj, nextStep){
        if(nextStep === 2){            
            this.setState({step: nextStep, 
                objCustomer: obj
            });            
        }  
    }

    async loadCurrencyList(customerId) {
        /*getCurrencyList().then(
            (response) => {
                if (typeof response !== "undefined") {
                    let currencies = response.currencies;
                    currencies.forEach(element => {
                        element.value = element.CurrencyID;
                        element.name = element.CurrencyIDName;
                    });
                    this.setState({
                        listActiveCurrencies: currencies
                    });
                }
            }
        )*/
        const currenciesResponse = await getCurrenciesDenominationsByCustomer(customerId);
        if(currenciesResponse && currenciesResponse.currencies) {
            const formattedCurrencies = currenciesResponse.currencies.map(c => ({ ...c, name: c.CurrencyIDName, value: c.CurrencyID }));
            const finalCurrencies = [];
            formattedCurrencies.forEach(element => {
                switch (element.Type) {
                    case 'Settlement':
                        finalCurrencies.push(element);
                        break;
                    default:
                        break;
                }
            });
            finalCurrencies.forEach(element => {
                element.value = element.CurrencyID;
                element.name = element.CurrencyIDName;
            });
            this.setState({ listActiveCurrencies: finalCurrencies });
        }
    }

    loadInstruments(){
       /* getLookUpTable('Incoming Instruments').then(
            (response) => {
                if (typeof response !== "undefined" && response.lookUpTables !== "undefined") {
                    let instruments = response.lookUpTables[0];
                    instruments.lookUpTableDetails.forEach(element => {
                        element.value = element.LookUpTableDetail;
                        element.name = element.LookUpTableDetail;
                    });
                    var listInstruments = [];
                    listInstruments.push(instruments);
                    this.setState({
                        listInstruments: listInstruments
                    });                    
                }
            }
        );*/

        getInstrumentsByCustomer(this.props.customerID).then(
                    (json) => {
                        //alert(JSON.stringify(json));
                        let jsonInstruments = json.instruments;
                        if (jsonInstruments !== undefined) {
                            var incomingHelper = [];
                            var deliveryMethods = {};
                            for (var i = 0; i < jsonInstruments.length; i++) {
                                var instrumentElement = {
                                    value: jsonInstruments[i].Instrument,
                                    name: jsonInstruments[i].Instrument
                                };
                                if (jsonInstruments[i].InstrumentType === 'Incoming') {
                                    instrumentElement.deliveryMethods = jsonInstruments[i].DeliveryMethods;
                                    instrumentElement.accountsOnly = jsonInstruments[i].AccountsOnly;
                                    incomingHelper.push(instrumentElement);
        
                                    var list = [];
                                    if (jsonInstruments[i].DeliveryMethods !== '') {
                                        var methodsList = jsonInstruments[i].DeliveryMethods.split('§');
                                        for (var j = 0; j < methodsList.length; j++) {
                                            var item = { value: methodsList[j], name: methodsList[j] };
                                            list.push(item);
                                        }
                                    }
                                    deliveryMethods[jsonInstruments[i].Instrument] = list;
                                }
                            }
                            this.setState({
                                listInstruments: incomingHelper,
                                deliveryMethods: deliveryMethods
                            });
                        }
                    }
                );
    }

    render() {
        var stepScreen = [];

        var classNameStep1 = '', classNameStep2 = '';

        switch(this.state.step){
            case 1:
            default:
                classNameStep1 = 'uk-active';
                stepScreen.push(<WizardSearchCustomerForm key="customer-form"
                    onCustomerSelected={this.handleCustomerSelection.bind(this)}/>)
                break;
            case 2:
                classNameStep2 = 'uk-active';
                stepScreen.push(<SettlementApplicationForm key="settlement-form"
                customerID={this.state.objCustomer["Customer ID"]}
                activeCurrencies={this.state.listActiveCurrencies}
                incomingInstruments={this.state.listIncomingInstruments}
                typeRecordsApply = {this.state.typeRecordsApply}
                settlementOpenFromBoard={false}
                lockedSide={this.props.lockedSide}/>)
                break;
        }

        var settlementTitle = "";
        if (this.props.mainTitle != null) {
            settlementTitle = '';
        } else if (this.props.backLink != null && this.props.settlementOpenFromBoard != null) {
            settlementTitle = (
                <h3 className="uk-heading-divider" style={style.titleStyle}>
                    <button className="uk-button uk-button-text uk-margin-small-right min-width-0" onClick={this.handleBackLink.bind(this)}>
                        <i className="fa fa-arrow-left back-arrow-white"></i>
                    </button>
                    Settlement Information
                </h3>
            )
        }
        var settlementScreen = (<div>
            {settlementTitle}
            <div>
                <ul className="uk-tab">
                    <li className={classNameStep1}><a onClick={() => this.onClickStepTab(1)}>Search Customer</a></li>
                    <li className={classNameStep2}><a onClick={() => this.onClickStepTab(2)}>Settlement</a></li>
                </ul>
                {stepScreen}
            </div>
        </div>)

        return(
            <div>
                <div className="breadcrumb-div">
                    <Breadcrumb separator=">">
                        <Breadcrumb.Item className="breadcrumb-item" onClick={this.handleBackLink.bind(this)}>{this.props.mainTitle}</Breadcrumb.Item>
                        <Breadcrumb.Item className="breadcrumb-item-bold">Settlement Information</Breadcrumb.Item>
                    </Breadcrumb>
                </div>
                {settlementScreen}
            </div>
        )
    }
}